import AsyncStorage from "@react-native-async-storage/async-storage";

export const PENDING_ONBOARDING_EVENT_NAVIGATION_KEY =
  "pendingOnboardingEventNavigation";

const PENDING_ONBOARDING_EVENT_NAVIGATION_TYPE = "onboarding_event";
const PENDING_ONBOARDING_EVENT_MAX_AGE_MS = 5 * 60 * 1000;

const getPendingOnboardingEventNavigationItem = async () => {
  try {
    return await AsyncStorage.getItem(PENDING_ONBOARDING_EVENT_NAVIGATION_KEY);
  } catch (error) {
    // Optional navigation state should not break auth flows when web storage is unavailable.
    return null;
  }
};

const setPendingOnboardingEventNavigationItem = async (value) => {
  try {
    await AsyncStorage.setItem(PENDING_ONBOARDING_EVENT_NAVIGATION_KEY, value);
    return true;
  } catch (error) {
    // Optional navigation state should not break auth flows when web storage is unavailable.
    return false;
  }
};

const removePendingOnboardingEventNavigationItem = async () => {
  try {
    await AsyncStorage.removeItem(PENDING_ONBOARDING_EVENT_NAVIGATION_KEY);
  } catch (error) {
    // Optional cleanup can be skipped when web storage is unavailable.
  }
};

const normalizePendingOnboardingEventNavigation = (value) => {
  if (!value || typeof value !== "object") return null;

  const createdAt = Number(value.createdAt);
  const alias =
    typeof value.alias === "string" && value.alias.trim()
      ? value.alias.trim().toLowerCase()
      : null;
  const slug =
    typeof value.slug === "string" && value.slug.trim()
      ? value.slug.trim()
      : null;
  const event = value.event?.slug ? value.event : null;

  if (!Number.isFinite(createdAt)) return null;
  if (!alias && !slug && !event?.slug) return null;

  return {
    type: PENDING_ONBOARDING_EVENT_NAVIGATION_TYPE,
    createdAt,
    alias,
    slug: slug || event?.slug || null,
    event,
    openPaywall: value.openPaywall !== false,
  };
};

export const storePendingOnboardingEventNavigation = async ({
  alias,
  slug,
  event,
  openPaywall = true,
}) => {
  const payload = normalizePendingOnboardingEventNavigation({
    createdAt: Date.now(),
    alias,
    slug,
    event,
    openPaywall,
  });

  if (!payload) return null;

  const stored = await setPendingOnboardingEventNavigationItem(
    JSON.stringify(payload)
  );

  return stored ? payload : null;
};

export const readPendingOnboardingEventNavigation = async () => {
  const raw = await getPendingOnboardingEventNavigationItem();

  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    const payload = normalizePendingOnboardingEventNavigation(parsed);

    if (!payload) {
      await removePendingOnboardingEventNavigationItem();
      return null;
    }

    if (Date.now() - payload.createdAt > PENDING_ONBOARDING_EVENT_MAX_AGE_MS) {
      await removePendingOnboardingEventNavigationItem();
      return null;
    }

    return payload;
  } catch (error) {
    await removePendingOnboardingEventNavigationItem();
    return null;
  }
};

export const clearPendingOnboardingEventNavigation = async () => {
  await removePendingOnboardingEventNavigationItem();
};
